import { Dispatch, SetStateAction } from 'react';
import { GetAdminUsersResponse } from '@hooks/use-get-admin-users/use-get-admin-users';

export interface ImpersonateUserPayload {
  email: string;
  uuid: string;
}

export interface ImpersonateUserProps {
  isImpersonateModalOpen: boolean;
  setIsImpersonateModalOpen: Dispatch<SetStateAction<boolean>>;
}

export const IMPERSONATE_STEP_LIST = 'list';
export const IMPERSONATE_STEP_SELECT = 'select';
export const IMPERSONATE_STEP_LOGOUT = 'logout';

export type ImpersonateStep =
  | typeof IMPERSONATE_STEP_LIST
  | typeof IMPERSONATE_STEP_SELECT
  | typeof IMPERSONATE_STEP_LOGOUT;

export interface ImpersonateUserSelectContentProps {
  setStep: Dispatch<SetStateAction<ImpersonateStep>>;
  handleClose: () => void;
}

export interface ImpersonateUserListContentProps {
  email: string | undefined;
  setSelectedUser: Dispatch<SetStateAction<GetAdminUsersResponse | undefined>>;
  companyId?: string;
  onImpersonate?: (payload: ImpersonateUserPayload) => void;
}
